module.exports = __webpack_public_path__ + "img/cl2_3.1eb66aa9.png";